import { resetCaptcha } from '../../helpers/captchas';
import { getFormName } from '../../form-callbacks/general';
import { log } from '../../tracking/InternalLogger';
import { detectFormTest } from '../../helpers/detect-form-test';
export const submitFormWithThankYouPageCallback = (callbackData) => {
    log('Form submit result', {
        formName: getFormName(callbackData.formContainer),
        status: callbackData.xhr.status,
        isTest: detectFormTest(callbackData.data),
    });
    const isSuccess = callbackData.xhr.status >= 200 && callbackData.xhr.status < 300;
    if (isSuccess) {
        window.location.hash = '#thank-you';
    }
    if (!isSuccess) {
        const captchaContainer = callbackData.formContainer.querySelector('.captcha-container');
        if (!captchaContainer) {
            return true;
        }
        resetCaptcha(captchaContainer);
    }
    return true;
};
export const thankYouPageCallbacks = {
    submitFormWithThankYouPageCallback: (callbackData) => {
        if (!callbackData.formContainer.classList.contains('free-trial-form')) {
            submitFormWithThankYouPageCallback(callbackData);
        }
    },
};
